/**
 * Created by sun yi on 2016/11/17.
 * Modified by qipeng on 2017/03/28
 * 移动设备适配
 * ps: 此种解决方法需要和 rem 配合使用
 */

(function() {

    var fontSizeMatchDeviceWidth = function() {
        var deviceWidth = document.documentElement.clientWidth,
            devicePixelRatio = window.devicePixelRatio || 1,
            scale = 1 / devicePixelRatio;
            console.log('deviceWidth: ', deviceWidth, 'devicePixelRatio: ', devicePixelRatio)

        document.documentElement.style.fontSize = ( ( deviceWidth * 16 / 320 ) * devicePixelRatio ) + 'px';
        console.log(document.documentElement.style.fontSize);
        document.querySelector('meta[name="viewport"]').setAttribute(
            'content',
            'width=device-width,initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no'
        );
    };

    (function() {
        var ua = navigator.userAgent;
        if( /android/i.test(ua) || /ipad|itouch|iphone/i.test(ua) ) {
            fontSizeMatchDeviceWidth();
        } else {    // 在pc上按iphone 6 plus尺寸显示
            document.getElementById('container').style.maxWidth = '414px';
            document.getElementById('container').style.minWidth = '414px';
            document.documentElement.style.fontSize = '56.5px';
        }

        if( 'number' === typeof window.orientation && 'object' === typeof window.onorientationchange ) {
            window.addEventListener('orientationchange', function() {
                location.reload(false);
            }, false);
        } else {
            //为什么不用绑定resize?    请自测（即使做了防抖动，也会存在不好的体验）
        }
    })();

})();

// (function(doc, win) {
//     var docEl = doc.documentElement,
//         resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
//         recalc = function() {
//             var clientWidth = docEl.clientWidth;
//             if (!clientWidth) return;
//             docEl.style.fontSize = 20 * (clientWidth / 320) + 'px';
//         };
//     if (!doc.addEventListener) return;
//     win.addEventListener(resizeEvt, recalc, false);
//     doc.addEventListener('DOMContentLoaded', recalc, false);
// })(document, window);



// WEBPACK FOOTER //
// ./src/utils/set.rem.js